/**
 * Hedge calculation utilities
 * Pure functions for calculating plants and metres - uses metafield data dynamically
 * All values should come from variant metafields
 *
 * These functions are loaded globally and used by hedge-calculator-inline.js
 */

/**
 * Calculate the number of plants needed based on hedge length and density
 * @param {number} metres - Length of hedge in metres
 * @param {string} rowType - 'single' or 'double'
 * @param {number} plantsPerMeterSingle - Plants per metre for single row (from metafield)
 * @param {number} plantsPerMeterDouble - Plants per metre for double row (from metafield)
 * @returns {number} Number of plants needed (0 if invalid input)
 * @global
 */
// eslint-disable-next-line no-unused-vars
function calculatePlants(metres, rowType, plantsPerMeterSingle, plantsPerMeterDouble) {
  // Validate input
  if (!metres || metres <= 0 || !rowType || !plantsPerMeterSingle || !plantsPerMeterDouble) {
    return 0;
  }

  // Determine plants per metre based on row type
  const plantsPerMetre = rowType === 'double' ? plantsPerMeterDouble : plantsPerMeterSingle;

  // Calculate and round to nearest whole number
  return Math.round(plantsPerMetre * metres);
}

/**
 * Calculate the hedge length in metres based on number of plants and density
 * @param {number} plants - Number of plants
 * @param {string} rowType - 'single' or 'double'
 * @param {number} plantsPerMeterSingle - Plants per metre for single row (from metafield)
 * @param {number} plantsPerMeterDouble - Plants per metre for double row (from metafield)
 * @returns {number} Length in metres (0 if invalid input)
 * @global
 */
// eslint-disable-next-line no-unused-vars
function calculateMetres(plants, rowType, plantsPerMeterSingle, plantsPerMeterDouble) {
  // Validate input
  if (!plants || plants <= 0 || !rowType || !plantsPerMeterSingle || !plantsPerMeterDouble) {
    return 0;
  }

  // Determine plants per metre based on row type
  const plantsPerMetre = rowType === 'double' ? plantsPerMeterDouble : plantsPerMeterSingle;

  // Calculate metres and round to 2 decimal places
  return Math.round((plants / plantsPerMetre) * 100) / 100;
}
